export default __webpack_public_path__ + "static/media/1128040325513335.4ff3e69e.jpg";